import styled from "styled-components";

export const KeyboardContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: stretch;
  justify-content: stretch;

  .keyboard {
    width: 100%;
    height: 100%;
    display: grid;
    gap: 18px;
    padding: 18px;
    box-sizing: border-box;
  }

  /* 전화번호 입력용: 하단 2칸 구조 */
  .keyboard.telKeyboard {
    grid-template-columns: repeat(3, 1fr);
    grid-template-areas:
      "k1 k2 k3"
      "k4 k5 k6"
      "k7 k8 k9"
      "back k0 k0";
  }

  .keyboard.telKeyboard button:nth-child(1) {
    grid-area: k1;
  }
  .keyboard.telKeyboard button:nth-child(2) {
    grid-area: k2;
  }
  .keyboard.telKeyboard button:nth-child(3) {
    grid-area: k3;
  }
  .keyboard.telKeyboard button:nth-child(4) {
    grid-area: k4;
  }
  .keyboard.telKeyboard button:nth-child(5) {
    grid-area: k5;
  }
  .keyboard.telKeyboard button:nth-child(6) {
    grid-area: k6;
  }
  .keyboard.telKeyboard button:nth-child(7) {
    grid-area: k7;
  }
  .keyboard.telKeyboard button:nth-child(8) {
    grid-area: k8;
  }
  .keyboard.telKeyboard button:nth-child(9) {
    grid-area: k9;
  }
  .keyboard.telKeyboard button:nth-child(10) {
    grid-area: back;
  }
  .keyboard.telKeyboard button:nth-child(11) {
    grid-area: k0;
  }

  /* 비밀번호 등 일반 숫자패드 */
  .keyboard.defaultKeyboard {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(4, 1fr);
  }

  .keyboard button {
    position: relative;
    overflow: hidden;
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 28px;
    background:
      linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(247, 250, 252, 0.96) 100%);
    box-shadow:
      0 20px 40px rgba(15, 23, 42, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.95),
      inset 0 -1px 0 rgba(148, 163, 184, 0.10);

    font-weight: 1000;
    color: #0f172a;
    letter-spacing: -0.03em;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    user-select: none;

    transition:
      transform 0.08s ease,
      box-shadow 0.12s ease,
      filter 0.12s ease,
      border-color 0.12s ease,
      background 0.12s ease;
  }

  .keyboard button::before {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at top, rgba(255, 255, 255, 0.9), transparent 62%);
    pointer-events: none;
  }

  .keyboard button.number,
  .keyboard button.zero {
    font-size: clamp(42px, 3vw, 58px);
  }

  .keyboard button.function {
    font-size: clamp(22px, 1.6vw, 30px);
    font-weight: 900;
  }

  .keyboard button:hover {
    transform: translateY(-1px);
    box-shadow:
      0 24px 46px rgba(15, 23, 42, 0.10),
      inset 0 1px 0 rgba(255, 255, 255, 0.98),
      inset 0 -1px 0 rgba(148, 163, 184, 0.12);
    border-color: rgba(76, 128, 241, 0.18);
  }

  .keyboard button:active {
    transform: scale(0.985);
    filter: brightness(0.985);
    box-shadow:
      0 12px 24px rgba(15, 23, 42, 0.10),
      inset 0 2px 4px rgba(15, 23, 42, 0.06);
  }

  .keyboard button.ghost {
    background:
      linear-gradient(180deg, rgba(241, 245, 249, 0.98) 0%, rgba(226, 232, 240, 0.95) 100%);
    color: #334155;
    border-color: rgba(148, 163, 184, 0.18);
    box-shadow:
      0 16px 30px rgba(100, 116, 139, 0.10),
      inset 0 1px 0 rgba(255, 255, 255, 0.9);
  }

  .keyboard button.ghost:hover {
    border-color: rgba(100, 116, 139, 0.24);
    background:
      linear-gradient(180deg, rgba(248, 250, 252, 1) 0%, rgba(226, 232, 240, 0.98) 100%);
  }

  .keyboard button.zero {
    border-radius: 30px;
  }

  @media screen and (max-width: 1024px) {
    .keyboard {
      gap: 14px;
      padding: 14px;
    }

    .keyboard button {
      border-radius: 22px;
    }
  }

  @media screen and (max-width: 767px) {
    .keyboard {
      gap: 10px;
      padding: 10px;
    }

    .keyboard button {
      border-radius: 16px;
      box-shadow:
        0 10px 18px rgba(15, 23, 42, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.95);
    }

    .keyboard button.number,
    .keyboard button.zero {
      font-size: 28px;
    }

    .keyboard button.function {
      font-size: 14px;
    }
  }
`;

export const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 220px 1fr 220px;
  align-items: center;
  padding: 0 26px;
  height: 92px;
  width: 100%;
  border-bottom: 1px solid rgba(76, 128, 241, 0.12);
  background:
    radial-gradient(circle at top, rgba(120, 166, 255, 0.1) 0%, rgba(255, 255, 255, 0.96) 32%, #ffffff 100%);
  box-shadow: 0 6px 20px rgba(31, 42, 68, 0.04);
  position: relative;
  z-index: 10;

  .headerSide {
    display: flex;
    align-items: center;
  }

  .headerSide.left {
    justify-content: flex-start;
  }

  .headerSide.right {
    justify-content: flex-end;
  }

  .headerCenter {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    text-align: center;
    min-width: 0;
  }

  h2 {
    margin: 0;
    font-size: 32px;
    font-weight: 900;
    line-height: 1.1;
    letter-spacing: -0.04em;
    color: #1f2a44;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  button {
    border: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition:
      transform 0.15s ease,
      box-shadow 0.15s ease,
      background 0.15s ease,
      color 0.15s ease;
  }

  button:active {
    transform: translateY(1px) scale(0.985);
  }

  .iconBtn {
    height: 56px;
    min-width: 120px;
    padding: 0 20px;
    border-radius: 18px;
    background: linear-gradient(180deg, #ffffff 0%, #f6f9ff 100%);
    border: 1px solid rgba(76, 128, 241, 0.12);
    box-shadow:
      0 8px 18px rgba(76, 128, 241, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.95);
    color: #2b3a55;
    gap: 10px;

    svg {
      font-size: 24px;
      flex-shrink: 0;
    }

    span {
      font-size: 20px;
      font-weight: 800;
      letter-spacing: -0.02em;
    }
  }

  .backBtn:hover {
    background: linear-gradient(180deg, #fafdff 0%, #edf4ff 100%);
  }

  .homeBtn {
    height: 56px;
    min-width: 152px;
    padding: 0 22px;
    border-radius: 18px;
    background: linear-gradient(135deg, #5c8dff 0%, #4c80f1 100%);
    color: #ffffff;
    box-shadow: 0 12px 26px rgba(76, 128, 241, 0.24);
    gap: 10px;

    svg {
      font-size: 23px;
      flex-shrink: 0;
    }

    span {
      font-size: 20px;
      font-weight: 800;
      letter-spacing: -0.02em;
    }
  }

  .homeBtn:hover {
    box-shadow: 0 14px 30px rgba(76, 128, 241, 0.28);
    transform: translateY(-1px);
  }

  @media screen and (max-width: 767px) {
    grid-template-columns: 88px 1fr 110px;
    padding: 0 12px;
    height: 62px;

    .headerCenter {
      gap: 3px;
    }

    .titleBadge {
      height: 18px;
      padding: 0 8px;
      font-size: 9px;
    }

    h2 {
      font-size: 18px;
      font-weight: 800;
    }

    .iconBtn {
      min-width: 52px;
      height: 42px;
      padding: 0 10px;
      border-radius: 12px;
      gap: 0;

      svg {
        font-size: 20px;
      }

      span {
        display: none;
      }
    }

    .homeBtn {
      min-width: 92px;
      height: 42px;
      padding: 0 12px;
      border-radius: 12px;
      gap: 6px;

      svg {
        font-size: 16px;
      }

      span {
        font-size: 13px;
      }
    }
  }
`;

export const ActionConfirmationContainer = styled.div`
  height: calc(100% - 86px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;

  .box {
    width: 100%;
    max-width: 980px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 28px;
    padding: 40px 36px 36px;
    border-radius: 36px;
    background:
      radial-gradient(circle at top, rgba(126, 169, 255, 0.18) 0%, rgba(255, 255, 255, 0.96) 38%, #ffffff 100%);
    box-shadow:
      0 18px 50px rgba(76, 128, 241, 0.12),
      inset 0 1px 0 rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(76, 128, 241, 0.12);
  }

  .topBadge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 130px;
    height: 42px;
    padding: 0 18px;
    border-radius: 999px;
    background: linear-gradient(135deg, #e8f0ff 0%, #dce9ff 100%);
    color: #3e6fd8;
    font-size: 18px;
    font-weight: 800;
    box-shadow: 0 8px 20px rgba(76, 128, 241, 0.12);
  }

  .tit {
    font-size: 44px;
    font-weight: 900;
    line-height: 1.25;
    letter-spacing: -0.04em;
    color: #1f2a44;
  }

  /* =========================
     완료 화면
  ========================= */

  .storageGroups {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 6px;
  }

  .storageGroup {
    width: 100%;
    padding: 22px 22px 24px;
    border-radius: 28px;
    background: linear-gradient(180deg, #f8fbff 0%, #eef4ff 100%);
    border: 1px solid rgba(76, 128, 241, 0.1);
    box-shadow: 0 10px 24px rgba(76, 128, 241, 0.08);
  }

  .groupHeader {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 16px;
  }

  .groupHeader .icon {
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .groupHeader .icon svg {
    width: 30px;
    height: 30px;
    stroke-width: 2.2;
  }

  .groupHeader .iconType0 svg {
    stroke: #2563eb;
    color: #2563eb;
  }

  .groupHeader .iconType1 svg {
    stroke: #d97706;
    color: #d97706;
  }

  .groupHeader .iconType2 svg {
    stroke: #334155;
    color: #334155;
  }

  .groupHeader .label {
    font-size: 26px;
    font-weight: 800;
    color: #24324a;
    letter-spacing: -0.03em;
  }

  .storageCards {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 14px;
  }

  .storageCard {
    min-width: 132px;
    height: 110px;
    padding: 12px 18px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, #ffffff 0%, #f6f9ff 100%);
    border: 2px solid rgba(76, 128, 241, 0.14);
    box-shadow:
      0 10px 24px rgba(76, 128, 241, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.95);
  }

  .cardNum {
    font-size: 46px;
    font-weight: 900;
    line-height: 1;
    letter-spacing: -0.03em;
    color: #3568d4;
  }

  .con {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 4px;
  }

  .con span {
    display: block;
    font-size: 28px;
    font-weight: 700;
    line-height: 1.45;
    color: #2c3a52;
    letter-spacing: -0.03em;
  }

  .con .tel {
    margin-top: 6px;
    color: #4c80f1;
    font-weight: 800;
  }

  .actions {
    margin-top: 6px;
  }

  .actions button {
    min-width: 220px;
    height: 74px;
    border: none;
    border-radius: 22px;
    background: linear-gradient(135deg, #5b8cff 0%, #4c80f1 100%);
    color: #fff;
    font-size: 28px;
    font-weight: 800;
    letter-spacing: -0.02em;
    box-shadow: 0 14px 28px rgba(76, 128, 241, 0.24);
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
  }

  .actions button:active {
    transform: translateY(2px);
    box-shadow: 0 8px 18px rgba(76, 128, 241, 0.2);
  }

  /* =========================
     결제 화면
  ========================= */

  &.paymentSummary {
    align-items: stretch;
    justify-content: center;
  }

  .payWrap {
    width: 100%;
    max-width: 980px;
    display: flex;
    flex-direction: column;
    gap: 22px;
  }

  .payHeader {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .payHeader .badge {
    width: fit-content;
    min-width: 96px;
    height: 38px;
    padding: 0 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background: linear-gradient(135deg, #e8f0ff 0%, #dce9ff 100%);
    color: #3e6fd8;
    font-size: 16px;
    font-weight: 800;
    box-shadow: 0 8px 20px rgba(76, 128, 241, 0.12);
  }

  .payHeader .title {
    font-size: 44px;
    font-weight: 900;
    line-height: 1.2;
    letter-spacing: -0.04em;
    color: #1f2a44;
  }

  .payHeader .sub {
    font-size: 22px;
    font-weight: 700;
    line-height: 1.5;
    color: #64748b;
    letter-spacing: -0.02em;
  }

  .payHeader .sub b {
    color: #1d4ed8;
  }

  .payCard {
    width: 100%;
    padding: 30px 28px 28px;
    border-radius: 32px;
    background: linear-gradient(180deg, #f8fbff 0%, #eef3fb 100%);
    border: 1px solid rgba(76, 128, 241, 0.12);
    box-shadow:
      0 16px 40px rgba(76, 128, 241, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.95);
  }

  .payCardTop {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 22px;
  }

  .payCardTop .left {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .payCardTop .cardTitle {
    font-size: 28px;
    font-weight: 900;
    color: #111827;
    letter-spacing: -0.03em;
  }

  .payCardTop .cardDesc {
    font-size: 18px;
    font-weight: 700;
    color: #6b7280;
  }

  .payCardTop .pill {
    height: 44px;
    padding: 0 18px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(76, 128, 241, 0.1);
    color: #2f66e7;
    font-size: 18px;
    font-weight: 800;
    white-space: nowrap;
  }

  /* 카드형 세로 레이아웃 */
    .payList {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  .payRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    padding: 20px 22px;
    border-radius: 28px;
    background: rgba(255, 255, 255, 0.72);
    border: 1px solid rgba(76, 128, 241, 0.08);
  }

  .payRow .rowLeft {
    display: flex;
    align-items: center;
    gap: 20px;
    min-width: 0;
    flex: 1;
  }

  .payRow .icon {
    width: 112px;
    height: 112px;
    border-radius: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: #e9eef9;
  }

  .payRow .icon svg {
    width: 60px;
    height: 60px;
    stroke-width: 2.1;
  }

  .payRow .iconType0 {
    background: rgba(59, 130, 246, 0.12);
  }

  .payRow .iconType1 {
    background: rgba(245, 158, 11, 0.12);
  }

  .payRow .iconType2 {
    background: rgba(100, 116, 139, 0.12);
  }

  .payRow .iconType0 svg {
    stroke: #2563eb;
    color: #2563eb;
  }

  .payRow .iconType1 svg {
    stroke: #d97706;
    color: #d97706;
  }

  .payRow .iconType2 svg {
    stroke: #334155;
    color: #334155;
  }

  .payRow .meta {
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    text-align: left;
  }

  .payRow .meta .name {
    font-size: 38px;
    font-weight: 1000;
    line-height: 1.12;
    letter-spacing: -0.03em;
    color: #111827;
  }

  .payRow .meta .calc {
    font-size: 24px;
    font-weight: 800;
    color: #6b7280;
    letter-spacing: -0.02em;
  }

  .payRow .rowRight {
    flex-shrink: 0;
    min-width: 150px;
    text-align: right;
    font-size: 30px;
    font-weight: 1000;
    color: #334155;
    letter-spacing: -0.03em;
  }

  .divider {
    width: 100%;
    height: 1px;
    background: rgba(100, 116, 139, 0.18);
    margin: 20px 0 18px;
  }

  .totalBox {
    min-height: 98px;
    border-radius: 28px;
    padding: 0 26px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(180deg, #edf3ff 0%, #e0ebff 100%);
    border: 1px solid rgba(76, 128, 241, 0.14);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.95);
  }

  .totalBox .label {
    font-size: 26px;
    font-weight: 800;
    color: #475569;
  }

  .totalBox .value {
    font-size: 40px;
    font-weight: 1000;
    letter-spacing: -0.04em;
    color: #245fdd;
  }

  .payActions {
    margin-top: 22px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
  }

  .payActions .payBtn {
    min-width: 320px;
    height: 76px;
    border: none;
    border-radius: 24px;
    background: linear-gradient(135deg, #5b8cff 0%, #4c80f1 100%);
    color: #fff;
    font-size: 28px;
    font-weight: 900;
    letter-spacing: -0.02em;
    box-shadow: 0 16px 30px rgba(76, 128, 241, 0.24);
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
  }

  .payActions .payBtn:hover {
    filter: brightness(1.02);
  }

  .payActions .payBtn:active {
    transform: translateY(2px);
    box-shadow: 0 10px 18px rgba(76, 128, 241, 0.18);
  }

  .payActions .payBtn:disabled {
    cursor: not-allowed;
    filter: grayscale(0.08);
    opacity: 0.7;
    box-shadow: none;
  }

  .payActions .hint {
    font-size: 18px;
    font-weight: 700;
    color: #64748b;
  }

  @media screen and (max-width: 767px) {
    padding: 14px;

    .box {
      gap: 18px;
      padding: 24px 18px 20px;
      border-radius: 24px;
    }

    .topBadge {
      min-width: 96px;
      height: 34px;
      font-size: 13px;
      padding: 0 14px;
    }

    .tit {
      font-size: 28px;
    }

    .storageGroups {
      gap: 12px;
    }

    .storageGroup {
      padding: 16px 14px 18px;
      border-radius: 20px;
    }

    .groupHeader {
      gap: 8px;
      margin-bottom: 12px;
    }

    .groupHeader .icon {
      width: 24px;
      height: 24px;
    }

    .groupHeader .icon svg {
      width: 22px;
      height: 22px;
    }

    .groupHeader .label {
      font-size: 18px;
    }

    .storageCards {
      gap: 10px;
    }

    .storageCard {
      min-width: 92px;
      height: 76px;
      border-radius: 18px;
      padding: 10px 12px;
    }

    .cardNum {
      font-size: 28px;
    }

    .con {
      gap: 5px;
    }

    .con span {
      font-size: 17px;
    }

    .con .tel {
      margin-top: 4px;
    }

    .actions button {
      min-width: 160px;
      height: 56px;
      font-size: 20px;
      border-radius: 16px;
    }

    .payWrap {
      gap: 14px;
    }

    .payHeader .badge {
      min-width: 76px;
      height: 30px;
      padding: 0 12px;
      font-size: 12px;
    }

    .payHeader .title {
      font-size: 28px;
    }

    .payHeader .sub {
      font-size: 15px;
      line-height: 1.45;
    }

    .payCard {
      padding: 18px 14px 16px;
      border-radius: 22px;
    }

    .payCardTop {
      margin-bottom: 14px;
      gap: 10px;
    }

    .payCardTop .cardTitle {
      font-size: 20px;
    }

    .payCardTop .cardDesc {
      font-size: 13px;
    }

    .payCardTop .pill {
      height: 34px;
      padding: 0 12px;
      font-size: 13px;
    }

        .payList {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .payRow {
      padding: 12px 12px;
      gap: 12px;
      border-radius: 20px;
    }

    .payRow .rowLeft {
      gap: 12px;
    }

    .payRow .icon {
      width: 72px;
      height: 72px;
      border-radius: 20px;
    }

    .payRow .icon svg {
      width: 38px;
      height: 38px;
    }

    .payRow .meta {
      gap: 6px;
    }

    .payRow .meta .name {
      font-size: 24px;
    }

    .payRow .meta .calc {
      font-size: 16px;
    }

    .payRow .rowRight {
      min-width: auto;
      font-size: 20px;
    }

    .payRow .rowRight .subtotalLabel {
      font-size: 13px;
    }

    .payRow .rowRight .subtotalValue {
      font-size: 22px;
    }

    .divider {
      margin: 14px 0 12px;
    }

    .totalBox {
      min-height: 72px;
      border-radius: 20px;
      padding: 0 16px;
    }

    .totalBox .label {
      font-size: 18px;
    }

    .totalBox .value {
      font-size: 28px;
    }

    .payActions {
      margin-top: 16px;
      gap: 10px;
    }

    .payActions .payBtn {
      min-width: 220px;
      height: 58px;
      font-size: 20px;
      border-radius: 18px;
    }

    .payActions .hint {
      font-size: 13px;
    }
  }
`;

export const KioskStepContainer = styled.div`
  height: calc(100% - 86px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 44px 60px;
  background: radial-gradient(1200px 700px at 50% 0%, #eef4ff 0%, #f7f8fb 55%, #f5f6f8 100%);

  .wrap {
    width: min(1040px, 100%);
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  .header {
    text-align: center;
  }

  .badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    padding: 0 16px;
    border-radius: 999px;
    background: rgba(76, 128, 241, 0.12);
    color: #2f66e7;
    font-weight: 1000;
    font-size: 18px;
    margin-bottom: 10px;
  }

  .title {
    font-size: 54px;
    font-weight: 1100;
    letter-spacing: -0.04em;
    color: #111827;
    margin-bottom: 8px;
  }

  .sub {
    font-size: 22px;
    font-weight: 800;
    color: #6b7280;
  }

  .card {
    flex: 1;
    background: rgba(255, 255, 255, 0.92);
    border: 1px solid rgba(17, 24, 39, 0.08);
    border-radius: 28px;
    box-shadow: 0 28px 70px rgba(0, 0, 0, 0.10);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .inputBar {
    height: 150px;
    padding: 18px 22px;
    background: rgba(243, 246, 251, 0.85);
    border-bottom: 2px solid rgba(17, 24, 39, 0.06);
  }

  .inputBar input {
    width: 100%;
    height: 100%;
    border: 2px solid rgba(17, 24, 39, 0.10);
    border-radius: 22px;
    background: rgba(255, 255, 255, 0.95);
    text-align: center;
    font-size: 54px;
    font-weight: 1100;
    letter-spacing: -0.03em;
    color: #111827;
  }

  .inputBar.hasRight {
    position: relative;
    display: flex;
    align-items: center;
  }

  .rightBtn {
    position: absolute;
    right: 64px;
    top: 50%;
    transform: translateY(-50%);
    width: 72px;
    height: 72px;
    border-radius: 18px;
    border: 2px solid rgba(17, 24, 39, 0.10);
    background: rgba(255, 255, 255, 0.92);
    box-shadow: 0 10px 26px rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    transition: transform 0.08s ease, filter 0.12s ease;
  }

  .rightBtn svg {
    font-size: 30px;
    color: #334155;
  }

  .rightBtn:active {
    transform: translateY(-50%) scale(0.98);
    filter: brightness(0.98);
  }

  .body {
    flex: 1;
    min-height: 0; /* 키보드 overflow 방지 */
  }

  @media screen and (max-width: 767px) {
    height: calc(100% - 50px);
    padding: 14px;

    .title {
      font-size: 22px;
    }
    .sub {
      font-size: 12px;
    }
    .badge {
      height: 28px;
      font-size: 12px;
    }
    .card {
      border-radius: 18px;
    }
    .inputBar {
      height: 80px;
      padding: 10px;
    }
    .inputBar input {
      border-radius: 14px;
      font-size: 22px;
    }
  }
`;